import classNames from 'classnames/bind';
import React, { useState, useEffect } from 'react';

import { ItemWithSubmenu } from '../item-with-submenu/item-with-submenu.view';

import styles from './header-nav.module.scss';

// local helper function for imitating Link activeClassName behavior
const isActiveLink = (path) => {
  let isActiveLink = false;
  // check if window object is defined (we are in browser)
  if (typeof window !== 'undefined') {
    // extracting last pieceof path for flexibility
    const givenPath = path.replace(/.*(\/.+?)$/, '$1');
    // getting the same piece from window and removing possible trailing slash
    const actualPath = window.location.pathname.replace(/\/$/, '');
    // comparing them
    isActiveLink = givenPath === actualPath;
  }
  return isActiveLink;
};

export const HeaderNav = ({ links }) => {
  const [shouldBeHighlighted, setShouldBeHighlighted] = useState({
    check: () => false,
  });
  useEffect(() => {
    setShouldBeHighlighted({ check: isActiveLink });
  }, []);

  return (
    <ul className={styles.list}>
      {links.map(({ label, to, submenu }) => (
        <li className={classNames(styles.item)} key={label + to}>
          {submenu ? (
            <ItemWithSubmenu label={label} submenu={submenu} shouldBeHighlighted={shouldBeHighlighted} />
          ) : (
            <a
              className={classNames(styles.link, {
                [styles.linkActive]: shouldBeHighlighted.check(to),
              })}
              href={to}
            >
              {label}
            </a>
          )}
        </li>
      ))}
    </ul>
  );
};
